import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ProjectProcessService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of project processes.
     * @datatask 47
     * @datataskName sp_ws_p2_projectprosess_list
     * @param params
     * @returns promise containing list of project processes.
     */
    public getProjectProcesses(params?: GetProjectProcessesParams): Promise<ProjectProcessItem[]> {
        return this.datatask.Post(47, params);
    }
}

export interface GetProjectProcessesParams {
    custact?: string | number;
    show_only_timeentry_allowed?: '1' | '0';
    project_keyno?: string | number;
}

export interface ProjectProcessItem {
    projectprosess_keyno: string;
    projectprosess_name: string;
    complete: string;
    orderby: string;
}
